<template>
  <NuxtChild />
</template>
<script>
export default {
  middleware({ store, redirect, route }) {
    // Only redirect if the current path is exactly the parent path
    if (route.path === '/fitness/group-training' || route.path === '/fitness/group-training/') {
      const clubs = store.getters['modules/content/clubs']
      const defaultSlug = clubs.length ? clubs[0].slug : 'default-club'
      return redirect(`/fitness/group-training/${defaultSlug}`)
    }
  },
}
</script>
